// bm-design-system: accordion primitive
//
// Built on native <details>/<summary> rather than a Radix primitive — the
// browser already gives us expand/collapse, keyboard support and correct
// semantics for free. Styled to the Private Cellar mockup's hairline/serif
// look (research/design-direction/mockup-b-private-cellar.html); see
// app/frontend/styles/public-occasions.css for the `.acc*` rules.
import * as React from "react";
import { cn } from "@/lib/utils";
import "@/styles/public-occasions.css";

export interface AccordionProps extends React.HTMLAttributes<HTMLDivElement> {}

export function Accordion({ className, ...props }: AccordionProps) {
  return <div className={cn("acc", className)} {...props} />;
}

export interface AccordionItemProps
  extends Omit<React.DetailsHTMLAttributes<HTMLDetailsElement>, "title"> {
  question: React.ReactNode;
  defaultOpen?: boolean;
}

export function AccordionItem({
  question,
  defaultOpen = false,
  className,
  children,
  ...props
}: AccordionItemProps) {
  return (
    <details className={cn("acc-item", className)} open={defaultOpen || undefined} {...props}>
      <summary className="acc-trigger">
        <span>{question}</span>
        <span className="acc-icon" aria-hidden="true" />
      </summary>
      <div className="acc-panel">{children}</div>
    </details>
  );
}

export interface AccordionGroupProps extends Omit<React.HTMLAttributes<HTMLDivElement>, "title"> {
  title: React.ReactNode;
}

export function AccordionGroup({ title, className, children, ...props }: AccordionGroupProps) {
  return (
    <div className={cn("acc-group", className)} {...props}>
      <h2 className="acc-group-title">{title}</h2>
      {children}
    </div>
  );
}
